<!-- 调价记录 -->
<template>
  <div>
    <div class="table-fixed">
      <a-table ref="table" size="middle" :scroll="{x: 'max-content'}" bordered rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap"
        :components="drag(columns)" @change="handleTableChange">
      </a-table>
    </div>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {
    mixinDevice
  } from '@/utils/mixin'
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'
  import {
    AreaChoosetMixin
  } from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import {
    getAction,
    httpAction
  } from '@/api/manage'
  import moment from 'moment'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil'
  import Vue from 'vue'
  import TableDragResize from '@/mixins/TableDragResize'
  import {
    isUndefined,
    isNull,
    isUndefinedAndNull
  } from '@/utils/validate'
  export default {
    name: 'PriceAdjustmentRecord',
    mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
    components: {},
    props: {
      id: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        description: 'PriceAdjustmentRecord管理页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/meterPriceChangeRecord/list",
        },
      }
    },
    watch: {
      id(val) {
        if (val) {
          this.loadData();
        }
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [{
            title: this.$t('表编号'),
            align: "center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('用户编号'),
            align: "center",
            dataIndex: 'userId'
          },
          {
            title: this.$t('用户名称'),
            align: "center",
            dataIndex: 'userName'
          },
          {
            title: this.$t('旧价格信息'),
            align: "center",
            dataIndex: 'oldPrice',
            customRender: (t, r, index) => {
              if (isNull(r.oldPriceWtTotalPrice) || r.oldPriceWtTotalPrice == '') {
                return "--"
              }
              return r.oldPriceWtName + '(' + r.oldPriceWtTotalPrice + this.$t('元') + ')'
            }
          },
          {
            title: this.$t('新价格信息'),
            align: "center",
            dataIndex: 'newPrice',
            customRender: (t, r, index) => {
              if (isNull(r.newPriceWtTotalPrice) || r.newPriceWtTotalPrice == '') {
                return "--"
              }
              return r.newPriceWtName + '(' + r.newPriceWtTotalPrice + this.$t('元') + ')'
            }
          },
          {
            title: this.$t('变更方式'),
            align: "center",
            dataIndex: 'changeWay',
            customRender: (t, r, index) => {
              let data = {
                1: this.$t('立即结算'),
                2: this.$t('扣完再启用新价格')
              }
              if (isUndefined(data[t])) {
                return this.$t('其他')
              }
              return data[t]
            }
          },
          {
            title: this.$t('新价格启用日期'),
            align: "center",
            dataIndex: 'startDate'
          },
          {
            title: this.$t('创建时间'),
            align: "center",
            dataIndex: 'createTime',
          }, {
            title: this.$t('创建人'),
            align: "center",
            dataIndex: 'createBy'
          }
        ]
      }
    },
    methods: {
      loadData() {
        var params = this.getQueryParams(); //查询条件
        params.userId = this.id;
        getAction(this.url.list, params).then(res => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>